import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import '../css/Register.css';
import Vas from '../Vas';
import { ExtendedButton,TextField,Loading,Icon } from "component-lib";

import { CheckPassword } from 'utils-lib';

import { PasswordModel, RequestAjaxClass } from 'models-lib';

class Activate  extends Component {

    constructor(props)
    {
        super(props);
        this.state = {};
        // Decode Token 
        let token = decodeURIComponent(window.location.pathname.split('/activate/')[1]);
        this.state.Id = token;
        this.PasswordModel = new PasswordModel([this]);
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);

    }

    componentDidMount(){
        this.setState({ requiredFields:[this.refs.newPassword, this.refs.retypePassword] },()=>{
            this.checkFields();
        });
        this.Request.setAuth(false);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setErrorHandler(()=>{
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });
        this.PasswordModel.SetRequest(this.Request);

        this.PasswordModel.GetPaswordPolicy();
    }

    componentDidUpdate(){
        this.checkFields();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "PaswordPolicy"){
          ReactDOM.render(
            <div>{this.PasswordModel.CountMinNumbers} {Vas.Resources.Labels["AtLeastNumbers"]}<br />
              {this.PasswordModel.CountMinLetters} {Vas.Resources.Labels["AtLeastChars"]}<br />
              {this.PasswordModel.CountMinSpecialCharacters} {Vas.Resources.Labels["AtLeastLowerChars"]}
              {this.PasswordModel.CountMinSpecialCharacters} {Vas.Resources.Labels["AtLeastUpperChars"]}
              {this.PasswordModel.CountMinSpecialCharacters} {Vas.Resources.Labels["AtLeastSymbols"]}<br />
              
              
              </div>
          ,document.getElementById("policy"));
          me.setState({ PasswordModus:[this.PasswordModel.PasswordLength,
                                       this.PasswordModel.CcountNumbers,
                                       this.PasswordModel.CountLetters,
                                       this.PasswordModel.CcountLowerCaseLetters,
                                       this.PasswordModel.CountUpperCaseLetters,
                                       this.PasswordModel.CountMinSpecialCharacters] });
        }
        else if (observer === "ChangePassword"){
          Vas.clearLocalStorage();
          Vas.GetView('ActivateSuccess',null,false);
        }
      });
    }
    
    CheckPassword(){
      if (document.getElementById(this.refs.newPassword.props.Id).value.length > 0){
          
        if (CheckPassword.Check(document.getElementById(this.refs.newPassword.props.Id).value,this.state.PasswordModus) === true){
            this.refs.IconPassword.setState({ Name:"Done",Color:"green" });
        } else {
            this.refs.IconPassword.setState({ Name:"Warning",Color:"red" });
        }
      } else {
          this.refs.IconPassword.setState({ Name:"Warning",Color:"red" });
      }
    }

    checkFields(){
        $("#error2").removeClass().addClass("hide");
        if (this.state.requiredFields){
            let count=this.state.requiredFields.length;
            let filled=0;
            for (let i=0;i<this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length>0){
                            filled++;
                    }
                }
            }
            if (filled < count){
                this.refs.btoActivate.setState({ usable:false });
            } else {
                if (document.getElementById(this.refs.retypePassword.props.Id).value !== document.getElementById(this.refs.newPassword.props.Id).value){
                    $("#error2").removeClass().addClass("show");
                    this.refs.btoActivate.setState({ usable:false });
                } else {
                    this.refs.btoActivate.setState({ usable:true });
                }
            }
        }
    }

    Activate()
    {
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
        localStorage.setItem('vas_token',(this.state.Id));
        this.PasswordModel.ChangePassword("",$("#retypePassword").val());
    }

    render()
    {
        return (
          <div className={"RegisterContainer"}>
            <div className={"form"}>
              <h2> { Vas.Resources.Titles["Activation"] }</h2>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <TextField 
                          AppURL={Vas.ApplicationUrl}
                          ref={"newPassword"}
                          Id={"password"}
                          Width={275}
                          Type={"password"}
                          Editable={true}
                          name="password"
                          Label={Vas.Resources.Labels["Password"]}
                          Tooltip={Vas.Resources.Tooltips["Pwd"]}
                          OnBlur={(e,val)=>{ this.setState({ password: val });}}
                          OnChange={()=>{this.CheckPassword();}} />
                        <Icon 
                          ref={"IconPassword"}
                          Name={"Warning"}
                          Size={24}
                          Color={"red"}
                          Align={"left"} />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <TextField 
                          AppURL={Vas.ApplicationUrl} 
                          Id={"retypePassword"} 
                          ref={"retypePassword"} 
                          Width={300} 
                          Type={"password"} 
                          Editable={true} 
                          name="retypePassword" 
                          Label={Vas.Resources.Labels["RetypePassword"]} 
                          Tooltip={Vas.Resources.Tooltips["Firstname"]} 
                          OnChange={(e,val)=>{ this.setState( { retypePassword: val });}}  />
                      </td>
                    </tr>
                    <tr><td className={"ConfirmationLabel"}>{Vas.Resources.Labels["PasswordPolicy"]} {Vas.Resources.Labels["LeastNumberChars"]}</td></tr>
                    <tr><td 
                      id={"policy"} 
                      className={"ConfirmationLabel"}></td></tr>
                    <tr><td 
                      id={"error2"} 
                      className={"hide"}>{Vas.Resources.Labels["PasswordNotMatch"]}</td></tr>
                    <tr>
                      <td>
                        <ExtendedButton 
                          Usable={false} 
                          Text={Vas.Resources.Labels["Activate"]} 
                          ref={"btoActivate"} 
                          Width={143} 
                          OnClick={()=>{ this.Activate(); }} 
                          style={{ margin: 5 }} 
                          Float={'left'} />
                        <ExtendedButton 
                          Usable={true} 
                          Text={Vas.Resources.Labels["Cancel"]} 
                          Width={143} 
                          OnClick={()=>{Vas.GetView('Login');}} 
                          Float={'left'} 
                          style={{ margin: 5 }} />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
    }
}
export default Activate;
